import { Controller } from "@hotwired/stimulus";
import tippy from "tippy.js";
import "tippy.js/themes/light.css";

export default class extends Controller {
  static values = {
    content: String,
    placement: { type: String, default: "top" },
  };

  connect() {
    this.tooltip = tippy(this.element, {
      content: this.contentValue,
      placement: this.placementValue,
      theme: "light",
      allowHTML: true,
    });
  }

  disconnect() {
    if (this.tooltip) {
      this.tooltip.destroy();
    }
  }

  contentValueChanged(newValue) {
    if (this.tooltip) {
      this.tooltip.setContent(newValue);
    }
  }

  placementValueChanged(newValue) {
    if (this.tooltip) {
      // there’s no built-in placement setter, so you’d need to destroy & recreate,
      // or use Tippy’s `setProps` API:
      this.tooltip.setProps({ placement: newValue });
    }
  }
}
